import { useState } from "react";
import Explore from "./Explore";
import Booked from "./Booked";
import Upcoming from "./Upcoming";
import Completed from "./Completed";
import SearchWithCheckbox from "../../../Components/ExploreSearch/SearchWithCheckbox";
import FilterChips from "../../../Components/ExploreSearch/FilterChips";

const SessionSchedule = () => {
  const tabs = [
    { name: "Explore", id: 1 },
    { name: "Booked Session", id: 2 },
    { name: "Upcoming Session", id: 3 },
    { name: "Complete Session", id: 4 },
  ];

  const [active, setActive] = useState(1);

  return (
    <>
      <div className="bg-white 3xl:mt-[12px] shadow-[0px_5px_16px_rgba(0,0,0,0.06)] 3xl:pt-[30px] py-[28px] rounded-b-[20px] mt-[28px] pt-[60px] px-[22px] desktop:!mt-0">
        <div className="w-full flex ">
          {active === 1 && (
            <div className="w-[23%] shadow-sm">
              {" "}
              <div>
                <h5>Filter</h5>
                <FilterChips />
              </div>{" "}
              <div>
                <SearchWithCheckbox />
                <SearchWithCheckbox />
                <SearchWithCheckbox />
              </div>
            </div>
          )}

          <div className={`${active === 1 ? "w-[77%] " : "w-full "}  `}>
            <div className=" flex justify-evenly pr-[20%]  font-bold">
              {tabs.map((tab, index) => {
                return (
                  <h3
                    onClick={() => {
                      setActive(index + 1);
                    }}
                    key={index}
                    className={`${
                      active === tab?.id
                        ? " text-[#239403] border-b-4 rounded-sm border-[#239403] "
                        : ""
                    } pb-4 text-[18px] cursor-pointer`}
                  >
                    {tab?.name}
                  </h3>
                );
              })}
            </div>

            {/* tab panel */}

            <div className="tab-panel">
              {active === 1 && <Explore />}
              {active === 2 && <Booked />}
              {active === 3 && <Upcoming />}
              {active === 4 && <Completed />}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SessionSchedule;
